import { register } from '../core/bootstrapper';

import CookieMessageView from './cookieMessageView';
import AlternativeCountryView from './alternativeCountryView';
import NewsletterView from './newsletterView';
import MainMenu from '../../home24/modules/common/mainmenu';
import HelpArea from './helparea/helparea';

/*
 register bootstrap function
 */
register(null, () => {
    new CookieMessageView({
        el: $('.cookies-msg')
    });

    new AlternativeCountryView({
        el: $('#alternative-country-box')
    });

    new NewsletterView({
        el: $('.footer-wrapper')
    });

    new MainMenu();
    new HelpArea();
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/layoutBootstrap.js
 **/